"use client";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";

import {
  COLOR_BLACK,
  COLOR_GREYSCALE_BLACK_75,
  COLOR_PRIMARY_BLACK,
  COLOR_PRIMARY_WHITE,
} from "~/theme/colors";

import { BREADCRUMBS_PANEL_CLASSES } from "./constants";

export const BreadcrumbsPanelContainer = styled(Container)(({ theme }) => ({
  background: COLOR_PRIMARY_WHITE,
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  [`& .${BREADCRUMBS_PANEL_CLASSES.link}`]: {
    "& a": {
      textDecoration: "none",
      color: COLOR_PRIMARY_BLACK,
    },
    "& li:last-child > *": {
      color: COLOR_PRIMARY_BLACK,
      textDecoration: "none",
      pointerEvents: "auto",
      "&:hover": {
        color: COLOR_GREYSCALE_BLACK_75,
        textDecoration: "underline",
      },
      "&:active": {
        color: COLOR_BLACK,
        textDecoration: "underline",
      },
    },
  },
}));
